/* eslint-disable max-len */

/** フロントエンド URL */
// const FRONT_DOMAIN = 'd2e3xmk2pvbp1g.cloudfront.net';
const FRONT_DOMAIN = 'int.web.dev.tkts.denryoku-nes.com';
const FRONT_URL = `https://${FRONT_DOMAIN}`;
// TODO: FRONT_URLをドメインに戻したら、WIJMO_LICENSE_KEYのドメイン部分を${FRONT_DOMAIN}にする

/** バックエンド URL */
// const BACK_DOMAIN = FRONT_DOMAIN;
const BACK_DOMAIN = 'int.api.dev.tkts.denryoku-nes.com';
const API_URL = `https://${BACK_DOMAIN}/`;

export default {
  'logger': false,
  'consolelog': true,
  'API_URL': API_URL,
  'WIJMO_LICENSE_KEY': `${FRONT_DOMAIN},983196771682363#B0YIIYHNyAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TQJhWcqhGeydGcw4mQyE5LSB5QHRlbxhnVZFjToxWWr2iaRJDV8RjepZTcrMmUBJ6TyFlYaNHNxc5ayZUUX3iVkhGUplkexlzM8tCcpdnaad7TzcVMQ3kS9BXULJFWE94dzgHTLtSdrVDR8ZnbxRnMR3ieTFVVkR7Mah6UwB7M7dzLxkndVBjev34cHt6TD3WN8Z6SZZXM5NHdDlXOvZVZmJWUGtCdWxUclZDM5kTazQ7N6F5SuhzQohjbQJnaOdWVXBnbWpmSM9EZlFmS9cFe9tEcwEWTOhHcmNTS63WT9NUVaZVOiJ7SONXQ0l4Uu3EdUV6R89UQvFkel5GVpFDMThFNVlWaw44L0h7QW54N9k5TUhHU5JjZwI4RvhzRkRTU4NmUWFGU5Rzbwlkd9YGbhN5YsJ4NspUdqJHTYd7KZFkQKhHTpJ4SDhjc8kDO8Bzb5BDV6hmI0IyUiwiICVkMyMzQ7YjI0ICSiwCMwUTMxIjNyITM0IicfJye=#Qf35VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiIxMzN5ATMgQDMzATNyAjMiojI4J7QiwiIt36YuMXZu5Sdr3Wey9WZk9yc4tGdiojIz5GRiwiI+S09ayL9Pyb9qCq9/K882O88ZO88OO88kK88zO88nO887K882O88lO88qO883K88DVkTiojIh94QiwiIzYzMygjNxczN6kTMzgTOiojIklkIs4XXbpjInxIZMw`,
  'MANUAL_PDF_URL': `${FRONT_URL}/manual/manual.pdf`,

  /** Cognito認証設定 */
  'amplify_conf': {
    Auth: {
      // REQUIRED - Amazon Cognito Region
      region: 'ap-northeast-1',
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: 'ap-northeast-1_5Hrkpht7u',
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: '206gm5rvjk3vjhpp3290pj8cja',
      // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
      mandatorySignIn: false,
    },
  },
};
